import React, { useContext } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './StockDisplay.css'
import { StockContext } from '../../Context/StockContext'

const StockDisplay = () => {
  const {stocksDF, loading_stock_df} = useContext(StockContext)

  return (
    <section className='Stock-Display p-2 d-flex justify-content-center align-items-center'>
      {loading_stock_df ? <div className="spinner-border text-info" role="status">
        <span className="sr-only"></span> </div> 
        
        : 

      <table className="table table-striped">
  <thead style={{position: "sticky", top: '0px'}}>
    <tr>
      <th>#</th>
      <th>Date</th>
      <th>Stock Name</th>
      <th>Price</th>
    </tr>
  </thead>

  <tbody>
  {Array.isArray(stocksDF) && stocksDF.map( (stock, index) =>  
  
  <tr key={index}>
  <td>{index + 1}</td>
  <td>{stock.date}</td>
  <td>{stock.company_name}</td>
  <td>₹. {stock.EndOfDay_price}/-</td>
</tr>)}

</tbody>
</table>    
      }
    </section>
  )
}

export default StockDisplay